import {Service} from '@/request/http.js'

// 登录
export function signIn (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 邮箱验证
export function emailVerify (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 忘记密码
export function forgetPass (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 邮箱确认
export function emailRetype (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 忘记密码修改密码
export function emailChangePassword (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

export function changeSource (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

export function getCountryInfo (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/login.js